<template>
  <div class="m-edition-section-content-subject m-edition-asset-contents">
    <blockquote
      v-if="!nodos.length"
      class="quote quote-assets-primary quote-first"
    >
      <p>
        <span>
          {{ $t('mEditionAssetContents.quote.thirdText') }}
          {{ $t('mEditionAssetContents.quote.fourthText') }}
        </span>
      </p>
    </blockquote>

    <div
      v-if="nodos.length"
      class="m-edition-section-content-subject-split-edition"
    >
      <div class="m-edition-section-content-subject-split-edition-item-left">
        <div class="display-flex-row-center margin-bottom-medium">
          <AtomButtonSecondary
            :button-secondary="buttonSecondary.createNode"
            :element="contenidos[0]"
            @showModal="$modal.showModal"
          />

          <div class="m-dropdown-primary m-edition-asset-contents-search">
            <p class="a-input-wrapper-row margin-zero align-items-center">
              <input
                v-model="busqueda"
                autocomplete="off"
                class="a-input-primary margin-bottom-zero"
                name="busqueda"
                placeholder="Buscar..."
              />
            </p>
            <MoleculeEditionAssetContentsDropDownSearch
              :resultados="resultadoBusqueda"
            />
          </div>
        </div>

        <MoleculeEditionAssetContentsTreeNodeFixed
          :contenido="contenidos[0]"
          :disabledDragg="disabledDragg"
          :disabledSelected="disabledSelected"
          :is-child="false"
          level="0"
          node-actions="Operations"
          node-actions-class="not-displayed"
          :nodos="nodos"
          @emitAction="changeOrder"
        />
      </div>

      <div class="m-edition-section-content-subject-split-edition-item-right">
        <MoleculeContentEditor/>
      </div>
    </div>
    <div v-else>
      <AtomButtonSecondary
        :button-secondary="buttonSecondary.createNode"
        :element="contenidos[0]"
        @showModal="$modal.showModal"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionAssetContents',

  components: {
    MoleculeEditionAssetContentsDropDownSearch: () => import('@/components/molecules/MoleculeEditionAssetContentsDropDownSearch'),
    MoleculeContentEditor: () => import('@/components/molecules/MoleculeContentEditor'),
    MoleculeEditionAssetContentsTreeNodeFixed: () => import('@/components/molecules/MoleculeEditionAssetContentsTreeNodeFixed')
  },

  props: {
    element: Object,
    elementCategorias: Array
  },

  data () {
    return {
      busqueda: '',

      buttonSecondary: {
        createNode: {
          class: 'a-button-assets-secondary display-flex-row-center margin-right-small text-color-assets-primary',
          component: 'MoleculeEditionAssetContentsModalCreateContent',
          icon: 'far fa-plus',
          method: 'showModal',
          text: this.$t('mEditionAssetContents.buttonSecondary.createNodeText'),
          type: 'button'
        }
      },

      disabledDragg: false,
      disabledSelected: false,
      nodos: [],

      ordenNodos: {
        academia: '',
        jerarquias: []
      },

      resultadoBusqueda: null,
      showLoadingState: true
    }
  },

  computed: {
    contenidos () {
      return [...this.$store.getters.getAssetContents]
    },

    contenidoNodos () {
      return this.$store.getters.getAssetNodes
    },

    nodo () {
      return Object.assign({}, this.$store.getters.getAssetSelectedNode)
    }
  },

  watch: {
    busqueda () {
      if (this.busqueda === '') {
        this.resultadoBusqueda = null
        this.$dropDown.closeDropDown('MoleculeEditionAssetContentsDropDownSearch')
      } else {
        this.resultadoBusqueda = this.searchTree(this.nodos, this.busqueda)
        if (this.resultadoBusqueda !== null) {
          this.$dropDown.openDropDown('MoleculeEditionAssetContentsDropDownSearch')
        }
      }
    },

    contenidoNodos: {
      deep: true,

      handler () {
        this.nodos = this.$store.getters.getAssetNodes
        console.log('watch store')
        console.log(this.nodos)
      }
    },

    nodo () {
      this.busqueda = ''
    }
  },

  created () {
    this.ordenNodos.academia = this.$store.getters.getAcademyData.id
    this.nodos = [...this.$store.getters.getAssetNodes]
  },

  methods: {
    changeOrder (params) {
      this.ordenNodos.jerarquias = []
      params.nodos.forEach((nodo, index) => {
        this.setJerarquias(nodo, index)
      })
      if (params.event.moved || params.event.removed) {
        let nodeID = params.event.moved
          ? params.event.moved.element.id
          : params.event.removed.element.id
        this.updateContenidoJerarquiasNodos(nodeID)
      }
    },

    searchTree (tree, text) {
      let array = []

      tree.forEach(nodo => {
        var nodoNorm = nodo.nombre.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        var textNorm = text.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        if (nodoNorm.toLowerCase().includes(textNorm.toLowerCase())) {
          array.push(nodo)
        }

        if (nodo.children.length > 0) {
          let aux = this.searchTree(nodo.children, text)
          if (aux != null) {
            array.push(...aux)
          }
        }
      })

      if (array.length > 0) {
        return array
      } else {
        return null
      }
    },

    setJerarquias (nodo, orden, padre = null) {
      this.ordenNodos.jerarquias.push({ id: nodo.id, orden: orden, padre: padre })

      if (nodo.children.length > 0) {
        nodo.children.forEach((child, index) => {
          this.setJerarquias(child, index, nodo.id)
        })
      }
    },

    showLoadingNodeIcon (nodeID, loading) {
      if (document.getElementById(`node-icon-circle-${nodeID}`)) {
        document.getElementById(`node-icon-circle-${nodeID}`).style.display = loading ? 'block' : 'none'
      }

      if (document.getElementById(`node-icon-caret-${nodeID}`)) {
        document.getElementById(`node-icon-caret-${nodeID}`).style.display = loading ? 'none' : ''
        document.getElementById(`node-icon-move-${nodeID}`).style.display = loading ? 'none' : ''
      }
    },

    updateContenidoJerarquiasNodos (nodeID) {
      this.showLoadingNodeIcon(nodeID, true)
      if (!this.disabledDragg) {
        this.disabledDragg = true
        this.$services.update('contenido', 'updateContenidoJerarquiasNodos', this.ordenNodos, [this.$store.getters.getAssetContents[0].id])
          .then(response => {
            this.$modal.updateData('readElement')
            this.showLoadingNodeIcon(nodeID, false)
            this.$alerts.pushAlert('mEditionAssetContents', 'updateContenidoJerarquiasNodos', 'success')
            this.disabledDragg = false
          })
          .catch(error => {
            console.log(error)
            this.nodos = [...this.$store.getters.getAssetNodes]
            this.showLoadingNodeIcon(nodeID, false)
            this.$alerts.pushAlert('mEditionAssetContents', 'updateContenidoJerarquiasNodos', 'error', 'a-alert-danger')
            this.disabledDragg = false
          })
      }
    }
  }
}
</script>
